import { MouseEvent, MouseEventHandler, useCallback, useContext, useEffect, useState } from "react";
import Button from "../../Button/Button";
import { TranslationContext } from "../../../shared/providers/translation/translation.provider";
import { IDocumentsProps } from "./Documents.interface";
import { CONTENT_BASE_URL } from "../../../shared/constants";
import { ModuleContext } from "../../../shared/providers/module/module.provider";
import { ComponentTypes } from "../../../shared/interfaces/modules.interface";

function Documents(props: IDocumentsProps) {
    const { unitId, id, files } = props;
    const { translate } = useContext(TranslationContext);
    const [downloaded, setDownloaded] = useState<number[]>([]);
    const { lang } = useContext(TranslationContext);
    const { setProgress } = useContext(ModuleContext);

    const handleFileDownload = useCallback<MouseEventHandler<any>>((e: MouseEvent) => {
        const index = Number((e.target as HTMLElement)?.dataset.index);

        if (isNaN(index)) return;
        const file = files[index];

        setDownloaded(prev => {
            if (prev.includes(index)) return prev;
            return [...prev, index]
        });

        const a = document.createElement("a");
        a.href = CONTENT_BASE_URL + file.url + "?download=1";
        a.download = file.name;
        document.body.appendChild(a);

        // Trigger download
        a.click();

        // Clean up
        document.body.removeChild(a);

    }, [files])

    const handleProgress = useCallback(() => {
        if (lang && unitId) {
            setProgress({
                unitId: unitId,
                itemId: id,
                progress: 100,
                itemType: ComponentTypes.FILE,
                itemLocale: lang
            });
        }
    }, [lang, unitId]);

    useEffect(() => {
        if (files.length === downloaded.length) {
            handleProgress()
        }
    }, [downloaded, files])

    return (
        <section className="unit_item no_margins container-fluid gx-2 py-2">
            <div className="row gx-0">
                <div className="col-12">
                    <h2 className="text-h4-bd mb-12">
                        {translate("common.support_materials", "Support materials")}
                    </h2>
                    <article className="card card_documents p-1 bg-neutrals-white">
                        <h3 className="text-h4-bd mb-1">
                            {translate("common.documents", "Documents")}
                        </h3>
                        <ul className="w-100 my-n01">
                            {files.map((file, i) => (
                                <li key={i}>
                                    <Button
                                        onClick={handleFileDownload}
                                        data={
                                            { "data-index": i }
                                        }
                                        type="button"
                                        icon="Download"
                                        iconSize={24}
                                        isIconRight
                                        customCss="w-100 justify-content-between px-0 py-02 my-01">
                                        <div className="d-flex flex-column align-items-start gap-02">
                                            <span className="text-bd2-bd text-start">
                                                {file.name}
                                            </span>
                                            <div className="text-bd3-rg color-neutrals-neutral text-uppercase d-flex gap-02">
                                                <span>{file.ext.replace(".", "")}</span>{" "}
                                                <span>{file.size} KB</span>
                                            </div>
                                        </div>
                                    </Button>
                                </li>
                            ))}
                        </ul>
                    </article>
                </div>
            </div>
        </section >
    );
}

export default Documents;
